import { useEffect } from 'react';

const SCROLL_END_TOLERANCE_PX = 10;

/**
 * Listens for scroll and marks content as read when the user reaches the bottom.
 * Formula matches the original: scrollHeight - scrollTop < clientHeight + 10
 */
const useDetectScrollEnd = (elementRef, setter) => {
  useEffect(() => {
    const { current } = elementRef;
    if (!current) return undefined;

    const trackScroll = () => {
      if (current.scrollHeight - current.scrollTop < current.clientHeight + SCROLL_END_TOLERANCE_PX) {
        setter(true);
      } else {
        setter(false);
      }
    };

    current.addEventListener('scroll', trackScroll);
    return () => current.removeEventListener('scroll', trackScroll);
  }, [elementRef, setter]);
};

export default useDetectScrollEnd;
